export const NOTIFICATION_RULES_LIST_PATH = '/admin/process-management/notifications';
export const NOTIFICATION_RULE_NEW_PATH = '/admin/process-management/notifications/new';

export function notificationRuleUrl(ruleId: string): string {
  return `${NOTIFICATION_RULES_LIST_PATH}/rules/${ruleId}`;
}

export function isNotificationsCatalogSearchHidden(url: string): boolean {
  const path = url.split('?')[0] ?? '';
  return path.endsWith('/settings')
    || /\/notifications\/rules\/[^/]+$/.test(path);
}

export function isNotificationsRulesNavActive(url: string): boolean {
  const path = url.split('?')[0] ?? '';
  return path === NOTIFICATION_RULES_LIST_PATH
    || path.endsWith('/process-management/notifications')
    || path.endsWith('/notifications/new')
    || /\/notifications\/rules\/[^/]+$/.test(path);
}
